import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Swipe/Swipe';

export const SWIPE = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.SWIPE,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: SWIPE.displayName,
					selectable: true,
					draggable: true,
					expandable: true,
					expanded: true,
				},

				componentProps: {
					[UNIFORM_PROPS.onSwipe]: {
						left: '',
						right: '',
					},
					styles: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								// ...
							},
						},
					},
					other: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								// ...
							},
						},
					},
				},
				nodeProps: {
					id: generateNodeId(_id, SWIPE.displayName),
				},
			},
			children: [],
		},
	};
};

SWIPE.displayName = 'Swipe';
